import { cn } from '@/lib/utils/cn';

type Props = {
  icon: string;
  size?: 'sm' | 'md';
  className?: string;
};

export function IconBadge({ icon, size = 'sm', className }: Props) {
  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary',
        size === 'sm' ? 'h-7 w-7' : 'h-10 w-10',
        className
      )}
    >
      <span className={cn('material-symbols-outlined', size === 'sm' ? 'text-xs' : 'text-sm')}>
        {icon}
      </span>
    </span>
  );
}
